import axios from 'axios';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL_SOUSCRIRE_EN_LIGNE;
export const sendRappelConseiller = async (formData: FormData): Promise<InfosRappelResponse> => {
  const response = await axios.post(
    `${apiBaseUrl}/rappel/get-jours`,
    {
      numeroRappel: formData.get('numeroRappel'),
      jourRappel: formData.get('jourRappel'),
      heureRappel: formData.get('heureRappel'),
      objetRappel: formData.get('objetRappel'),

      nomRappel: formData.get('nomRappel') === 'null' ? null : formData.get('nomRappel'),
      prenomRappel: formData.get('prenomRappel') === 'null' ? null : formData.get('prenomRappel'),
      typeContactRappel: formData.get('typeContactRappel') === 'null' ? null : formData.get('typeContactRappel'),
      idSFRappel: formData.get('idSFRappel') === 'null' ? null : formData.get('idSFRappel'),
      emailRappel: formData.get('emailRappel') === 'null' ? null : formData.get('emailRappel'),
      cpRappel: formData.get('cpRappel') === 'null' ? null : formData.get('cpRappel'),
    },

    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  if (!response) {
    throw new Error('Erreur de format de donnée: sendRappelConseiller service');
  }
  const data = await response.data;
  return data;
};

export interface InfosRappelResponse {
  valide: boolean;
  status: number;
  origin: object;
}
